import { combineEpics } from "redux-observable";
import { epicGameTrackingDesktopDeviceInformation } from "./desktop-device-information/epicGameTrackingDesktopDeviceInformation";
import { epicUpdateTracking } from "./epics/epicUpdateTracking";
import { epicGameTrackingFpsAndMemoryUsage } from "./fps/epics/epicGameTrackingFpsAndMemoryUsage";
import { epicGameTrackingClientFunnel } from "./game-funnel/epicGameTrackingClientFunnel";
import { epicGameTrackingShop } from "./shop/epicGameTrackingShop";
export var epicGameTracking = combineEpics(epicGameTrackingClientFunnel, epicGameTrackingFpsAndMemoryUsage, epicGameTrackingShop, epicUpdateTracking, epicGameTrackingDesktopDeviceInformation);



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/epicGameTracking.ts
// module id = 1859
// module chunks = 3